module.exports = __webpack_public_path__ + "static/toodledo_2-64508d93be2da7dc9f2eefe5987d339a.png";